const cpf = [
    (cpf:any) => {
        const rawCpf = cpf.replace(/\D/g, "")

        if(rawCpf === ""){
            return "Informe um cpf"
        }
        else if(!isLengthCorrect(rawCpf) || areNumbersTheSame(rawCpf)){
            return "Informe um cpf válido"
        }
        else if (!areVerificationDigitsValid(rawCpf)){
            return "Informe um cpf válido"
        }
        else{
            return true
        }
    }
]

function isLengthCorrect(cpf:any){
    if(cpf.length >= 1 && cpf.length != 11){
        return false
    }
    else{
        return true
    }
}

function areNumbersTheSame(cpf:any){
    if(
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
    )
    {
        return true
    }
    else{
        return false
    }
}

function areVerificationDigitsValid(cpf:any){
    const cpfArray = cpf.split('')
    let firstDigitVerificator = getDigitVerificator(cpfArray,8,10)
    let secondDigitVerificator = getDigitVerificator(cpfArray,9,11)
    firstDigitVerificator = firstDigitVerificator === 10 || firstDigitVerificator === 11 ? 0 : firstDigitVerificator
    secondDigitVerificator = secondDigitVerificator === 10 || secondDigitVerificator === 11 ? 0 : secondDigitVerificator
    let isFirstDigitValid
    let isSecondDigitValid

    isFirstDigitValid = compareVerificationDigits(firstDigitVerificator,parseInt(cpfArray[9]))
    isSecondDigitValid = compareVerificationDigits(secondDigitVerificator,parseInt(cpfArray[10]))


    if(isFirstDigitValid && isSecondDigitValid){
        return true
    }
    else{
        return false
    }
}

function getDigitVerificator(cpfArray:any, limit:any, numberToDecrease:any){
    let result = 0
    for(let i = 0; i <= limit; i++){
        result += parseInt(cpfArray[i]) * numberToDecrease
        numberToDecrease--
    }

    const restOfDivision = Math.floor((result * 10) % 11)
    return restOfDivision
}

function compareVerificationDigits(verificator:any,digit:any){
    if(verificator === digit){
        return true
    }
    else{
        return false
    }
}

export default cpf